import type { ListaItens, SeletorItem } from '@Lar21/imaginii-web-components/vue'
import type {
  FiltrosCatalogoPerfilDePermissao,
  OpcaoPerfilDePermissao,
  SelecaoCatalogoPerfilDePermissao,
} from '../catalogo-perfil-de-permissao.tipos'

export const CHAVE_I18N_CATALOGO_PERFIL_DE_PERMISSAO =
  'srcNext.governanca.catalogoPerfilDePermissao'

export const filtrarOpcoesPerfilDePermissao = (
  opcoes: readonly OpcaoPerfilDePermissao[],
  filtros?: FiltrosCatalogoPerfilDePermissao,
  predicado?: (opcao: OpcaoPerfilDePermissao) => boolean,
): readonly OpcaoPerfilDePermissao[] => {
  if ((!filtros || Object.keys(filtros).length === 0) && !predicado) return opcoes
  return opcoes.filter(opcao => (filtros?.id === undefined || filtros.id.includes(opcao.id))
    && (filtros?.kind === undefined || filtros.kind.some(kind => opcao.kind === kind))
    && (!predicado || predicado(opcao)))
}

const item = (opcao: OpcaoPerfilDePermissao): SeletorItem => ({
  chave: opcao.id,
  valor: opcao.name,
  ...(typeof opcao.description === 'string' && opcao.description.trim() ? { legenda: opcao.description } : {}),
})
const listaSelecionada = (
  valor: SelecaoCatalogoPerfilDePermissao,
  multipla: boolean,
): readonly OpcaoPerfilDePermissao[] => {
  if (valor === null) return []
  if (!Array.isArray(valor)) return [valor as OpcaoPerfilDePermissao]
  if (multipla) return valor as readonly OpcaoPerfilDePermissao[]
  const primeira = valor[0] as OpcaoPerfilDePermissao | undefined
  return primeira ? [primeira] : []
}

export const criarEstadoSeletorCatalogoPerfilDePermissao = (
  opcoes: readonly OpcaoPerfilDePermissao[],
  valor: SelecaoCatalogoPerfilDePermissao,
  multipla: boolean,
): ListaItens => {
  const carregados = opcoes.filter(opcao => typeof opcao.id === 'string' && Boolean(opcao.id.trim()) && typeof opcao.name === 'string' && Boolean(opcao.name.trim())).map(item)
  const porId = new Map(carregados.map((i) => [String(i.chave), i]))
  return {
    carregados,
    selecionados: listaSelecionada(valor, multipla).flatMap((opcao) => {
      const selecionado = porId.get(opcao.id)
      return selecionado ? [selecionado] : []
    }),
  }
}

export const extrairValorDoSeletorCatalogoPerfilDePermissao = (
  estado: ListaItens,
  opcoes: readonly OpcaoPerfilDePermissao[],
  multipla: boolean,
): SelecaoCatalogoPerfilDePermissao => {
  const porId = new Map(opcoes.map((opcao) => [opcao.id, opcao]))
  const resultado = [...new Set(estado.selecionados.map(({ chave }) => String(chave)))]
    .flatMap((id) => {
      const opcao = porId.get(id)
      return opcao ? [opcao] : []
    })
  return multipla ? resultado : (resultado[0] ?? null)
}

type Traduzir = (chave: string) => string
export const criarPropriedadesPontotelSeletorPerfilDePermissao = ({
  traduzir, label, placeholder, erro,
}: Readonly<{
  traduzir: Traduzir
  label?: string
  placeholder?: string
  erro: string | null
}>) => ({
  tamanho: 'M' as const, largura: '100%', tamanhoPagina: 20,
  pesquisavel: true, recarregarTodos: true,
  label: label ?? traduzir(`${CHAVE_I18N_CATALOGO_PERFIL_DE_PERMISSAO}.label`),
  placeholder: placeholder ?? traduzir(`${CHAVE_I18N_CATALOGO_PERFIL_DE_PERMISSAO}.placeholder`),
  erro,
  traducaoNenhumResultado: traduzir(`${CHAVE_I18N_CATALOGO_PERFIL_DE_PERMISSAO}.nenhumResultado`),
  traducaoSelecionado: traduzir(`${CHAVE_I18N_CATALOGO_PERFIL_DE_PERMISSAO}.selecionado`),
  traducaoSelecionadosPlural: traduzir(`${CHAVE_I18N_CATALOGO_PERFIL_DE_PERMISSAO}.selecionados`),
  traducaoRecarregarTodos: traduzir(`${CHAVE_I18N_CATALOGO_PERFIL_DE_PERMISSAO}.recarregar`),
  traducaoRecarregado: traduzir(`${CHAVE_I18N_CATALOGO_PERFIL_DE_PERMISSAO}.recarregado`),
})
